import _ from 'lodash'
import moment from 'moment-timezone'

export default {
  methods: {
    getProductImage (product, folder) {
      if (_.isEmpty(product) || !product.id || (!folder && !product.product_lists[0])) {
        return ''
      }

      const productListFolder = folder || product.product_lists[0].folder

      return `${process.env.PRODUCT_API_HOST}/products/${productListFolder}/assets/${product.images_data[0]}`
    },

    getProductThumbnail (product, folder) {
      if (_.isEmpty(product) || !product.id || (!folder && !product.product_lists[0]) || !product.thumbnail) {
        return ''
      }

      const productListFolder = folder || product.product_lists[0].folder

      return `${process.env.PRODUCT_API_HOST}/products/${productListFolder}/assets/${product.thumbnail}`
    },

    // TODO: Temporary solution, full path should be feed from backend
    thumbnailFallback (event, product, folder) {
      event.target.src = this.getProductImage(product, folder)
    },
    getProductNameWithSku (product) {
      let name = product.name_zh_hk + (product.size ? ` - ${product.size}` : '')
      if (product.id !== product.sku && product.sku) {
        name += ' (' + product.sku + ')'
      }
      return name
    },
    getProductSku (product) {
      if (product.id === product.sku || !product.sku) {
        return '-'
      }
      return product.sku
    },

    getOutputData (product, locationData) {
      let price = product.price || product.recommended_price
      if (typeof price !== 'string') {
        const discount = this.getDiscount(price, product.promotion)
        let discountString = (discount && `$${discount.price.toFixed(1)}`) || ''
        if (discount && discount.description) {
          discountString += ` <span class="grey--text caption"> <s class="grey--text caption">$${price.toFixed(1)}</s> ${discount.description}<span>`
        }
        if (discount && this.isOnPromotion(product.promotion)) {
          price = `<strong>${discountString}</strong>`
        } else {
          price = price ? `<strong>$${price.toFixed(1)}</strong>` : '-'
        }
      }

      let output = {
        price: price,
        shelf_time: product.location_product ? parseInt(product.location_product.shelf_time) : '-',
        sold_out_time: product.location_product ? (product.location_product.sold_out_time * 100).toFixed(0) : '-',
        coil_sold: product.location_product ? parseFloat(product.location_product.coil_sold).toFixed(1) : '-',
        projected_sales_per_cycle: '-',
        price_overwritable: typeof product.price_overwritable === 'undefined' ? true : product.price_overwritable,
        promotion_overwritable: typeof product.promotion_overwritable === 'undefined' ? true : product.promotion_overwritable,
        drink_coil_acceptable_sizes: product.drink_coil_acceptable_sizes || [],
      }

      if (product.location_product) {
        let coilSold = parseFloat(product.location_product.coil_sold)
        let sellableTime = parseInt(product.location_product.shelf_time) * (1 - product.location_product.sold_out_time)
        output.projected_sales_per_cycle = (Math.ceil((coilSold / sellableTime * (locationData.replenishment_cycle > 60 ? 60 : locationData.replenishment_cycle)) * 10) / 10).toFixed(1)
      }

      return Object.assign(product, output)
    },
    getDiscount (originalPrice, promotion = null, promotionFromMachineConfig = true) {
      if (_.isEmpty(promotion)) {
        return null
      }

      const discountType = promotion.discount_type || null
      let discountValue = _.get(promotion, 'discount_value', null)

      if (!_.isFinite(discountValue)) {
        return {
          price: _.get(promotion, 'price', originalPrice),
          description: ''
        }
      }

      const discount = {
        description: '',
        price: discountValue
      }

      switch (discountType) {
        case 'percentage':
          discountValue = Math.abs(discountValue)
          if (!promotionFromMachineConfig) {
            discountValue /= 100
          }
          discount.price = _.ceil(originalPrice * discountValue, 1)
          discount.description = `${Math.round((1 - discountValue) * 100)}% off`
          break
        case 'dollar_off':
          discount.price = _.ceil(Math.max(originalPrice - discountValue, 0), 1)
          discount.description = `$${discountValue} off`
          break
        case 'fixed':
        default:
          discount.price = discountValue
      }

      return discount
    },

    isOnPromotion (promotion) {
      if (!promotion) {
        return false
      }

      const startAt = moment.unix(promotion.start_at)
      const endAt = moment.unix(promotion.end_at)
      const now = moment()

      const hasStarted = !promotion.start_at || startAt.isSameOrBefore(now)
      const hasEnded = promotion.end_at && now.isSameOrAfter(endAt)

      return hasStarted && !hasEnded
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/product.js